/**
 * 前端错误监控 SDK - 全局错误处理器
 * 安装 window.onerror 和 unhandledrejection 监听
 */
import type { CaptureExceptionOptions } from './types';

type CaptureExceptionFn = (error: unknown, options?: CaptureExceptionOptions) => void;

let installed = false;
let captureExceptionRef: CaptureExceptionFn | null = null;

export function installGlobalHandlers(captureException: CaptureExceptionFn): void {
  if (installed || typeof window === 'undefined') return;

  captureExceptionRef = captureException;

  window.addEventListener('error', (event) => {
    if (!captureExceptionRef) return;
    const error = event.error ?? new Error(event.message ?? 'Unknown error');
    captureExceptionRef(error, {
      level: 'error',
      extra: {
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
      },
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    if (!captureExceptionRef) return;
    const reason = event.reason;
    const error =
      reason instanceof Error ? reason : new Error(String(reason ?? 'Unhandled rejection'));
    captureExceptionRef(error, {
      level: 'error',
      extra: {
        promiseRejectionReason: typeof reason === 'object' ? undefined : String(reason),
      },
    });
  });

  installed = true;
}
